module.exports = __webpack_public_path__ + "img/privacy.b3a44063.webp";